import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ConfiguratorTablesView } from "src/components/views/erp/configurator/tables/ConfiguratorTablesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/configurator/tables")({
	staticData: { title: i18n.t("tables"), legacyViewKey: "configuratorTablesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ConfiguratorTablesView />;
}
